import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bhandara-rapid-chess',
  templateUrl: './bhandara-rapid-chess.component.html',
  styleUrls: ['./bhandara-rapid-chess.component.scss']
})
export class BhandaraRapidChessComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
